import * as React from 'react';

const ArrowRight: React.FC = () => (
    <svg className="icon icon--arrow-right" viewBox="0 0 100 100">
        <polygon points="43.08,88.33 37.42,82.67 70.09,50 37.42,17.33 43.08,11.67 81.41,50 " />
    </svg>
);

export default ArrowRight;
